/* HoundRide storefront helpers: scroll reveal, product gallery, bundle picker,
   sticky buy bar, delivery estimate. No dependencies, ~4 KB. */
(function () {
  'use strict';
  window.HR = window.HR || {};

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.hr-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var track = root.querySelector('[data-hr-track]');
    if (!track) return null;
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-hr-thumb]'));
    var count = root.querySelector('[data-hr-count]');
    var current = 0;

    function go(i) {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    function mark(i) {
      if (i === current) return;
      current = i;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (thumbs[i]) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      slides.forEach(function (s, n) {
        var v = s.querySelector('video');
        if (v && n !== i && !v.paused) v.pause();
      });
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        mark(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)));
      });
    }, { passive: true });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-hr-thumb'), 10)); });
    });
    var prev = root.querySelector('[data-hr-prev]');
    var next = root.querySelector('[data-hr-next]');
    if (prev) prev.addEventListener('click', function () { go(current === 0 ? slides.length - 1 : current - 1); });
    if (next) next.addEventListener('click', function () { go(current === slides.length - 1 ? 0 : current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(current + 1, slides.length - 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(current - 1, 0)); }
    });

    return {
      showMedia: function (mediaId) {
        if (!mediaId) return;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(mediaId)) { go(i); return; }
        }
      }
    };
  }

  /* ---------- Delivery estimate (business days, skips weekends) ---------- */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }
  function initEta(root) {
    root.querySelectorAll('[data-hr-eta]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10);
      var max = parseInt(el.getAttribute('data-max'), 10);
      var out = el.querySelector('[data-hr-eta-range]');
      if (!out || isNaN(min) || isNaN(max)) return;
      var fmt = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
      var now = new Date();
      out.textContent = fmt.format(addBusinessDays(now, min)) + ' – ' + fmt.format(addBusinessDays(now, max));
    });
  }

  /* ---------- Product: bundle picker + sticky bar ---------- */
  function initProduct(root) {
    var gallery = null;
    var g = root.querySelector('[data-hr-gallery]');
    if (g) gallery = initGallery(g);
    initEta(root);

    var dataEl = root.querySelector('[data-hr-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }

    var input = root.querySelector('[data-hr-variant-input]');
    var priceEl = root.querySelector('[data-hr-price]');
    var compareEl = root.querySelector('[data-hr-compare]');
    var saveEl = root.querySelector('[data-hr-save]');
    var saveAmt = root.querySelector('[data-hr-save-amount]');
    var atc = root.querySelector('[data-hr-atc]');
    var stickyPrice = root.querySelector('[data-hr-sticky-price]');
    var stickyBtn = root.querySelector('[data-hr-sticky-btn]');
    var opts = root.querySelectorAll('.hr-bundle__opt');

    function select(id) {
      var v = null;
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) v = variants[i];
      if (!v) return;
      if (input) input.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (compareEl) { compareEl.hidden = !v.compare; if (v.compare) compareEl.textContent = v.compare; }
      if (saveEl) { saveEl.hidden = !v.save; if (v.save && saveAmt) saveAmt.textContent = v.save; }
      [atc, stickyBtn].forEach(function (b) { if (b) b.disabled = !v.available; });
      opts.forEach(function (o) {
        var r = o.querySelector('input');
        o.classList.toggle('is-selected', r && parseInt(r.value, 10) === id);
      });
      if (gallery && v.media) gallery.showMedia(v.media);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    opts.forEach(function (o) {
      var r = o.querySelector('input');
      if (!r) return;
      r.addEventListener('change', function () { if (r.checked) select(parseInt(r.value, 10)); });
    });

    var sticky = root.querySelector('[data-hr-sticky]');
    var buy = root.querySelector('[data-hr-atc]') || root.querySelector('[data-hr-buy]');
    if (sticky && buy && 'IntersectionObserver' in window) {
      document.body.classList.add('hr-has-sticky');
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      });
      io.observe(buy);
    }

    /* Keep the floating chat button off the prices while the shopper picks a setup */
    var buyZones = root.querySelectorAll('[data-hr-bundle], [data-hr-buy]');
    if (buyZones.length && 'IntersectionObserver' in window) {
      var zoneIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.target.toggleAttribute('data-hr-in-view', e.isIntersecting); });
        document.body.classList.toggle('hr-buy-in-view', !!root.querySelector('[data-hr-in-view]'));
      });
      buyZones.forEach(function (z) { zoneIo.observe(z); });
    }
  }

  /* ---------- Page sticky CTA (advertorial) ---------- */
  function initPageSticky() {
    document.querySelectorAll('[data-hr-page-sticky]').forEach(function (bar) {
      var offset = parseInt(bar.getAttribute('data-offset'), 10) || 600;
      document.body.classList.add('hr-has-sticky');
      var ticking = false;
      function update() {
        var show = window.scrollY > offset;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        ticking = false;
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
      update();
    });
  }

  // Gallery slides 2+ are rendered with data-src; load them after the page load event or on first touch
  function initDeferredImages() {
    var done = false;
    function load() {
      if (done) return;
      done = true;
      document.querySelectorAll('img[data-hr-defer]').forEach(function (img) {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        if (img.dataset.src) img.src = img.dataset.src;
        img.removeAttribute('data-hr-defer');
      });
    }
    if (document.readyState === 'complete') setTimeout(load, 300);
    else window.addEventListener('load', function () { setTimeout(load, 300); }, { once: true });
    document.addEventListener('pointerdown', function (e) { if (e.target.closest && e.target.closest('.hr-gallery')) load(); }, { passive: true });
  }

  function init() {
    initReveal();
    initDeferredImages();
    document.querySelectorAll('[data-hr-product]').forEach(initProduct);
    initPageSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    var p = e.target.querySelector('[data-hr-product]');
    if (p) initProduct(p);
    e.target.querySelectorAll('.hr-reveal').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
